<app-popover class="block w-[300px]">
  <div app-popover-header class="text-start text-sm font-normal italic text-base-gray-light-900">Filtrar por:</div>
  <div app-popover-content class="flex flex-col gap-2 p-4!">
    <button
      [ngClass]="{
        'bg-modules-eclass-500 text-white': selectedFilter === 'all',
      }"
      class="group flex h-10 w-full items-center justify-start rounded-full bg-modules-eclass-100 p-3 hover:bg-modules-eclass-500"
      (click)="onFilterSelected('all', groupedStudents.all)"
    >
      <p class="ml-2 group-hover:text-white group-active:text-white">
        {{ 'eclass.tarefa.todos' | translate }} ({{ groupedStudents.all.length }})
      </p>
    </button>
    @if (groupedStudents.corrected.length > 0) {
      <button
        [ngClass]="{
          'bg-modules-eclass-500 text-white': selectedFilter === 'corrected',
        }"
        class="group flex h-10 w-full items-center justify-start rounded-full bg-modules-eclass-100 p-3 hover:bg-modules-eclass-500"
        (click)="onFilterSelected('corrected', groupedStudents.corrected)"
      >
        <p class="ml-2 group-hover:text-white group-active:text-white">
          {{ 'eclass.tarefa.corrigido' | translate }} ({{ groupedStudents.corrected.length }})
        </p>
      </button>
    }
    @if (groupedStudents.completed.length > 0) {
      <button
        [ngClass]="{
          'bg-modules-eclass-500 text-white': selectedFilter === 'completed',
        }"
        class="group flex h-10 w-full items-center justify-start rounded-full bg-modules-eclass-100 p-3 hover:bg-modules-eclass-500"
        (click)="onFilterSelected('completed', groupedStudents.completed)"
      >
        <p class="ml-2 group-hover:text-white group-active:text-white">
          {{ 'eclass.tarefa.concluido' | translate }} ({{ groupedStudents.completed.length }})
        </p>
      </button>
    }
    @if (groupedStudents.pending.length > 0) {
      <button
        [ngClass]="{
          'bg-modules-eclass-500 text-white': selectedFilter === 'pending',
        }"
        class="group flex h-10 w-full items-center justify-start rounded-full bg-modules-eclass-100 p-3 hover:bg-modules-eclass-500"
        (click)="onFilterSelected('pending', groupedStudents.pending)"
      >
        <p class="ml-2 group-hover:text-white group-active:text-white">
          {{ 'eclass.tarefa.pendente' | translate }} ({{ groupedStudents.pending.length }})
        </p>
      </button>
    }
  </div>
</app-popover>
